var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgDish(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.322,
    height: 99.322,
    viewBox: "0 0 99.322 99.322",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "a"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.974 24.821)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M273.371,128.609l-1.063-3.5a7.6,7.6,0,0,0-14.389,0l-1.063,3.5a19.647,19.647,0,0,0-.548,9.1,8.563,8.563,0,0,0,4.41,5.968l-1.19,26.607a5.242,5.242,0,0,0,1.324,4.075,5.782,5.782,0,0,0,8.169.366q.191-.175.366-.366a5.172,5.172,0,0,0,1.324-3.965l-1.2-26.721a8.562,8.562,0,0,0,4.4-5.964A19.648,19.648,0,0,0,273.371,128.609Zm-2.713,8.529a5.249,5.249,0,0,1-3.435,3.955,1.655,1.655,0,0,0-1.071,1.624l1.258,27.944a1.914,1.914,0,0,1-.5,1.5,2.557,2.557,0,0,1-3.6,0,1.987,1.987,0,0,1-.487-1.609l1.248-27.835a1.655,1.655,0,0,0-1.071-1.624,5.249,5.249,0,0,1-3.435-3.955,16.324,16.324,0,0,1,.455-7.558l1.063-3.5a4.292,4.292,0,0,1,8.052,0l1.063,3.5A16.346,16.346,0,0,1,270.658,137.137Z",
    transform: "translate(-256.012 -119.955)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.141 24.831)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M152.554,120a1.655,1.655,0,0,0-1.655,1.655v14.213l-4.481,4.481a1.655,1.655,0,0,0-.485,1.253l1.448,28.969a2.255,2.255,0,0,1-.626,1.687,2.331,2.331,0,0,1-3.3.014l-.014-.014a2.254,2.254,0,0,1-.626-1.687l1.458-28.969a1.656,1.656,0,0,0-.483-1.253l-4.483-4.481V121.655a1.655,1.655,0,1,0-3.311,0v14.9a1.655,1.655,0,0,0,.485,1.17l4.446,4.448-1.412,28.239a5.592,5.592,0,0,0,11.17.544q.013-.272,0-.544l-1.412-28.239,4.446-4.448a1.655,1.655,0,0,0,.485-1.17v-14.9A1.656,1.656,0,0,0,152.554,120Z",
    transform: "translate(-136 -120)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.107 24.831)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M161.655,120A1.655,1.655,0,0,0,160,121.655V134.9a1.655,1.655,0,0,0,3.311,0V121.655A1.655,1.655,0,0,0,161.655,120Z",
    transform: "translate(-160 -120)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.074 24.831)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M185.655,120A1.655,1.655,0,0,0,184,121.655V134.9a1.655,1.655,0,0,0,3.311,0V121.655A1.655,1.655,0,0,0,185.655,120Z",
    transform: "translate(-184 -120)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M49.661,0A49.661,49.661,0,1,0,99.322,49.661,49.661,49.661,0,0,0,49.661,0Zm0,96.012a46.35,46.35,0,1,1,46.35-46.35A46.35,46.35,0,0,1,49.661,96.012Z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(44.305 79.24)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M224.843,384.443a1.656,1.656,0,0,0-1.808-1.487l-.064.007.007,0a30.4,30.4,0,0,1-7.015,0,1.656,1.656,0,0,0-.386,3.289,33.532,33.532,0,0,0,7.78,0A1.655,1.655,0,0,0,224.843,384.443Z",
    transform: "translate(-214.113 -382.949)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(70.207 27.738)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M344.076,134.645a1.655,1.655,0,0,0-2.332-.2l-.007.006a1.655,1.655,0,0,0-.2,2.332,29.8,29.8,0,0,1-1.756,40.3,1.656,1.656,0,0,0,2.337,2.346A33.108,33.108,0,0,0,344.076,134.645Z",
    transform: "translate(-339.295 -134.053)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.911 16.559)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M186.36,105.743h0Z",
    transform: "translate(-184.703 -100.422)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M198.94,80.947a33.4,33.4,0,0,0-19.485,1.2,1.654,1.654,0,1,0,1.16,3.1,30.073,30.073,0,0,1,17.547-1.076,1.655,1.655,0,1,0,.778-3.218Z",
    transform: "translate(-178.382 -80.027)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.551 29.484)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M91.991,183.689A29.793,29.793,0,0,1,89,145.138a1.655,1.655,0,0,0-2.647-1.989l-.029.039a33.107,33.107,0,0,0,3.322,42.844,1.658,1.658,0,1,0,2.346-2.344Z",
    transform: "translate(-79.989 -142.488)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDish);
export default __webpack_public_path__ + "static/media/dish.5946962db7590bdbb1c35357a262cf47.svg";
export { ForwardRef as ReactComponent };